import React from "react";
import { Wrapper, Title, Description } from "./styled";
import { TITLES } from "../../../../constants";

const MainColumn = () => {
  return (
    <Wrapper>
      <Title>{TITLES[0]}</Title>
      <Description>{TITLES[1]}</Description>
    </Wrapper>
  );
};

export default MainColumn;
